import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { PathTestLogDoc, PathTestLogService } from '../../core/services';
import { FormControl, Validators } from '@angular/forms';
import { AppState } from '../../core';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { PathTest } from '../../core/models';
import { BehaviorSubject, Subscription } from 'rxjs';
import { RxDocument } from 'rxdb';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-path-test-log',
  templateUrl: './path-test-log.component.html',
  styleUrls: ['./path-test-log.component.scss']
})
export class PathTestLogComponent extends FesBaseComponent implements OnInit, OnDestroy {

  querySubject : BehaviorSubject<RxDocument<PathTestLogDoc>[]>
  querySubscription : Subscription

  someCommentsDeleted = false
  @Input() testId = null;
  @Input() public set pathTest( t : PathTest ) {
    this._pathTest = t
    this.comments.reset()
    this.querySubscription?.unsubscribe()
    this.isLoading = true
    this.logService.doWhenReady( () => {
      this.getLogs()
    })
  }
  @Input() editable = true;

  public get pathTest() {
    return this._pathTest
  }
  private _pathTest : PathTest

  comments = new FormControl('');

  isLoading = false
  isEditing = false
  isSaving = false
  logEntries : PathTestLogDoc[] = []
  showDeleted = false

  constructor(
    appState: AppState,
    public logService: PathTestLogService,
    public modalService: BsModalService
    ) {
    super(appState)
    this.comments.setValidators( Validators.required )
  }

  ngOnInit(): void {
    if(this.testId){
      this.getLogs()
    }
  }

  ngOnDestroy(): void {
    this.querySubscription?.unsubscribe()
    this.destroy()
  }

  hasUnsavedComment() {
    return this.isEditing && this.comments.value?.length
  }

  async onSaveComment() {
    this.isSaving = true
    const taskLog = {
      text: this.comments.value,
      taskId: this.testId?this.testId:this._pathTest._id,
      timestamp: this.logService.nowTimeStamp(),
      userId: this.appState.getUser()._id
    }

    try {
      await this.logService.create( taskLog )
      this.logService.publishSuccess('Log entry added',this)
      this.comments.setValue('')
      this.isEditing = false
      return true
    } catch ( error ) {
      this.logService.publishError(error,this)
      return false
    } finally {
      this.isSaving = false;
    }
  }

  onCancelComment() : void {
    this.isEditing = false
    this.comments.setValue('')
  }

  async archive(log: PathTestLogDoc, bArchive : boolean ) {
    this.isSaving = true

    try {
      log = await log.atomicPatch({archived: bArchive})
      this.logService.publishSuccess((bArchive?'Deleted':'Restored') + ' log entry',this)
      return true
    } catch ( error ) {
      this.logService.publishError(error,this)
      return false
    } finally {
      this.isSaving = false;
    }
  }

  showDeletedChecked(val: any){
    this.showDeleted = val
  }

  async askDiscardEdits(acceptDiscardFn: () => void) {
    let initialState = {
      title: 'Unsaved Comment',
      onYes: acceptDiscardFn,
      question: 'Discard unsaved path test comment?',
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.show(ConfirmModalComponent, { initialState });
  }

  private getLogs() {
    this.querySubject = this.logService.rxCollection.find().where('taskId').eq(this.testId?this.testId:this._pathTest._id).sort({'timestamp':'desc'}).$
    this.querySubscription = this.querySubject.subscribe(
        async logEntries => {
          this.logEntries = logEntries
          this.someCommentsDeleted = logEntries.some(le=>le.archived)
          this.isLoading = false
        },
        error => {
          this.isLoading = false
          this.logService.publishError(error,this)
        }
    )
  }
}
